
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class LoanProductService {
  private baseApiUrl: string;

  constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
  }

  getFilteredLoanProducts(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean): Observable<any> {
    let params = new HttpParams();
    params = params.append('filter', filter);
    params = params.append('pageIndex', pageIndex.toString());
    params = params.append('pageSize', pageSize.toString());
    params = params.append('sortColumn', sortColumn);
    params = params.append('sortAscending', sortAscending.toString());
    console.log('Filter is ', params);
    return this.httpClient.get(this.baseApiUrl + 'loanProduct/filter', { params: params }).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getAllLoanProducts(): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + 'loanProduct').pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getLoanProduct(id: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `loanProduct/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  createLoanProduct(loanProduct: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'loanProduct', loanProduct).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  updateLoanProduct(loanProduct: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'loanProduct', loanProduct).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
}
